import { fetchWithAuthorization } from '../../../helpers/fetch-with-authorization';
import { VehicleStateResponse } from '../types';

export type GetSubscriptionDetailedStateFn = (payload: {
    request: {
        subscriptionId: string;
    };
    accessToken: string;
}) => Promise<VehicleStateResponse>;

export function initGetSubscriptionDetailedStateFn({
    baseUrl,
}: {
    baseUrl: string;
}): GetSubscriptionDetailedStateFn {
    const href =
        'client-orchestration/v1/detailed-state/subscription/{subscriptionId}';
    return async ({ request: { subscriptionId }, accessToken }) => {
        const url = `${baseUrl}/${href.replace('{subscriptionId}', subscriptionId)}`;
        const response = await fetchWithAuthorization({
            url,
            method: 'GET',
            accessToken,
        });
        if (!response.ok) return Promise.reject(await response.json());
        return response.json();
    };
}
